"use client";
import urlList from "@/urlList";
import axios from "axios";
import { useState, useEffect } from "react";
import "./Footer.css";
import {
  FaChevronCircleDown,
  FaChevronCircleUp,
  FaFacebook,
  FaLinkedin,
  FaYoutube,
} from "react-icons/fa";
import { useRouter } from "next/navigation";
import { FaSquareXTwitter, FaSquareInstagram } from "react-icons/fa6";
import { BsDot } from "react-icons/bs";

import Link from "next/link";

export default function FooterComponent() {
  const router = useRouter();

  const [departmentData, setDepartmentData] = useState([]);
  const [expandedViews, setExpandedViews] = useState<{
    [key: string]: boolean;
  }>({});

  useEffect(() => {
    axios.get(urlList.GET_DEPARTMENT).then((res: any) => {
      let data = res.data.data;
      data.forEach((dep: any) => {
        dep.skillList = [];
        while (dep.skills?.length) {
          dep.skillList.push(dep.skills.splice(0, 4));
        }
        let skill: any = [];
        dep.skillList.forEach((el: any) => {
          el.forEach((ele: any) => {
            skill.push(ele);
          });
        });
        dep.skills = skill;
      });
      setDepartmentData(data);
    });
  }, []);

  const toggleView = (departmentId: string) => {
    setExpandedViews((prev) => ({
      ...prev,
      [departmentId]: !prev[departmentId],
    }));
  };

  return (
    <>
      <div className="footer">
        <div className="col-md-11 px-md-0 d-flex mx-auto pt-4 respCol">
          <div className="w-[14vw] flex flex-col gap-4">

            <div className=" px-0 bg-[#3083C5] leftBody">
              <div>
                <p className="heading font-bold">INFO</p>
                <a className="cursor text-white" href="/contact-us">
                  Contact Us
                </a>
                <a className="cursor" href="https://careers.oodles.io/">
                  Careers
                </a>

              </div>
              <div>
                <p className="pt-[2vw] heading mt4 pt1 mx-[1vw] ">LEGAL</p>
                <a className="cursor" href="/privacy-policy">
                  Privacy Policy
                </a>
                <a className="cursor" href="/terms-and-conditions">
                  Terms & Conditions
                </a>
                <a className="cursor" href="/cookie-policy">
                  Cookie Policy
                </a>
              </div>
            </div>

            <div className=" px-0 bg-[#F5FBFE]  leftBodyColor">
              <p className="leftHeading font-bold text-[#2a2c2e]">VALUED SERVICES</p>
              <div className="flexM">
                <a className="cursor" href="https://www.oodlesmarketing.com/?utm_source=oodles.com" target="/blank">
                  Digital Marketing
                </a>
                <a className="cursor" href="https://blockchain.oodles.io/?utm_source=oodles.com" target="/blank">
                  Blockchain
                </a>
                <a className="cursor" href="https://artificialintelligence.oodles.io/?utm_source=oodles.com" target="/blank">
                  Artificial Inteligence
                </a>
                <a className="cursor" href="https://erpsolutions.oodles.io/?utm_source=oodles.com" target="/blank">
                  ERP Solutions
                </a>
                <a className="cursor" href="https://www.oodlestechnologies.com/?utm_source=oodles.com" target="/blank">
                  Immersive Media and Gaming
                </a>
                <a className="cursor" href="https://www.oodlesstudio.com/?utm_source=oodles.com" target="/blank">
                  Oodles Studiio
                </a>
              </div>
            </div>

          </div>
          <div className="width-80 px-0">
            <div className="mb-3 flex flex-col gap-6 px-0">
              {departmentData.map((dep: any) => (
                <div
                  className="flex flex-row bg-white rounded-lg px-4"
                  key={dep.departmentId}
                >
                  <div className="heading font12 colorBlack">
                    {dep.displayName ? dep.displayName : dep.department}
                  </div>
                  <div className="flex flex-wrap flex-col hidden md:block ">
                    <div
                      className={`pt-[1.5rem] ${expandedViews[dep.departmentId] ? "" : ""
                        }`}
                    >
                      {dep.skillList
                        .slice(
                          0,
                          expandedViews[dep.departmentId]
                            ? dep.skillList.length
                            : 4
                        )
                        .map((skillList: any, i: number) => (
                          <div key={i} className="d-flex flex-wrap w-100 ">
                            {skillList.map((skill: any, j: number) => (
                              <Link
                                key={j}
                                className="w-25 px-0 flex flex-wrap skillNames cursor"
                                href={skill.publishedUrl}
                              >
                                Hire {skill.displayName} {skill.tag}
                              </Link>
                            ))}
                          </div>
                        ))}
                    </div>

                    {dep.skills.length > 16 ? (
                      <div className="w-[60vw] pb-6 flex flex-col gap-4 xs: pr-[1rem] ">
                        <div className="line"></div>
                        <div className="text-right text-[#3083C5] flex justify-end items-center">
                          <div
                            className="text-[0.7rem] cursor-pointer font-bold pr-2"
                            onClick={() => toggleView(dep.departmentId)}
                          >
                            {expandedViews[dep.departmentId]
                              ? "View Less"
                              : "View All"}
                          </div>
                          {expandedViews[dep.departmentId] ? (
                            <FaChevronCircleUp
                              className="cursor-pointer text-sm"
                              onClick={() => toggleView(dep.departmentId)}
                            />
                          ) : (
                            <FaChevronCircleDown
                              className="cursor-pointer text-sm"
                              onClick={() => toggleView(dep.departmentId)}
                            />
                          )}
                        </div>
                      </div>
                    ) : (
                      ""
                    )}
                  </div>
                  <div className="flex flex-wrap flex-col md:hidden ">
                    <div
                      className={`pt-3 ${expandedViews[dep.departmentId] ? "" : ""
                        }`}
                    >
                      {dep.skillList
                        .slice(
                          0, expandedViews[dep.departmentId]
                          ? dep.skillList.length
                          : 2
                        )
                        .map((skillList: any, i: number) => (
                          <div key={i} className="d-flex flex-wrap w-100 ">
                            {skillList.map((skill: any, j: number) => (
                              <Link
                                key={j}
                                className={`${i == 1 && j > 0 && !expandedViews[dep.departmentId] ? "hidden" : "w-25 px-0 flex flex-wrap skillNames cursor"
                                  }`}
                                href={skill.publishedUrl}
                              >
                                Hire {skill.displayName} {skill.tag}
                              </Link>
                            ))}
                          </div>
                        ))}
                    </div>

                    {dep.skills.length > 5 ? (
                      <div className="w-[60vw] pb-6 flex flex-col gap-4 xs: pr-[1rem] ">
                        <div className="line"></div>
                        <div className="text-right text-[#3083C5] flex justify-end items-center">
                          <div
                            className="text-[0.7rem] cursor-pointer font-bold pr-2"
                            onClick={() => toggleView(dep.departmentId)}
                          >
                            {expandedViews[dep.departmentId]
                              ? "View Less"
                              : "View All"}
                          </div>
                          {expandedViews[dep.departmentId] ? (
                            <FaChevronCircleUp
                              className="cursor-pointer text-sm"
                              onClick={() => toggleView(dep.departmentId)}
                            />
                          ) : (
                            <FaChevronCircleDown
                              className="cursor-pointer text-sm"
                              onClick={() => toggleView(dep.departmentId)}
                            />
                          )}
                        </div>
                      </div>
                    ) : (
                      ""
                    )}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        <div className="w-[92vw] mx-auto ">
          <div className="newLine"></div>
          <div className="flex justify-between py-3 flex-wrap gap-3">
            <div className="flex gap-4 icons">
              <a
                href="https://www.facebook.com/oodlesplatform/"
                target="_blank"
              >
                <FaFacebook className="text-black cursor-pointer" />
              </a>
              <a
                href="https://www.linkedin.com/company/oodlesplatform/"
                target="_blank"
              >
                <FaLinkedin className="text-black cursor-pointer" />
              </a>
              <a href="https://x.com/oodlesplatform" target="_blank">
                <FaSquareXTwitter className="text-black cursor-pointer" />
              </a>
              <a
                href="https://www.instagram.com/oodlesplatform/"
                target="_blank"
              >
                <FaSquareInstagram className="text-black cursor-pointer" />
              </a>
              <a
                href="https://www.youtube.com/channel/UCItMS41aSRykF1u7IA7wpJw"
                target="_blank"
              >
                <FaYoutube className="text-black cursor-pointer" />
              </a>
            </div>
            <div className="flex gap-2 items-center footerRight flex-wrap">
              <span className="text-sm">V1.50.1</span>
              <span className="text-2xl font-bold">
                <BsDot />
              </span>
              <span className="text-sm">Copyright @</span>
              <a
                href="https://www.oodlestechnologies.com/"
                target="_blank"
                className="text-sm font-bold text-[#2f83c5]"
              >
                Oodles Technologies
              </a>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
